import { Node } from '@tiptap/core';

// Blockquote extension
export const Blockquote = Node.create({
  name: 'blockquote',
  group: 'block',
  content: 'block+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'blockquote',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['blockquote', HTMLAttributes, 0];
  },
});

// Code extension
export const Code = Node.create({
  name: 'code',
  group: 'inline',
  inline: true,
  content: 'inline*',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'code',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['code', HTMLAttributes, 0];
  },
});

// Pre extension
export const Pre = Node.create({
  name: 'pre',
  group: 'block',
  content: 'code*',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'pre',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['pre', HTMLAttributes, 0];
  },
});

// Image extension
export const Image = Node.create({
  name: 'image',
  group: 'block',
  inline: false,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element) => element.getAttribute('src'),
        renderHTML: (attributes) => {
          return {
            src: attributes.src,
          };
        },
      },
      alt: {
        default: null,
        parseHTML: (element) => element.getAttribute('alt'),
        renderHTML: (attributes) => {
          return {
            alt: attributes.alt,
          };
        },
      },
      title: {
        default: null,
        parseHTML: (element) => element.getAttribute('title'),
        renderHTML: (attributes) => {
          return {
            title: attributes.title,
          };
        },
      },
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'img',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', HTMLAttributes];
  },
});

// Table extensions
export const Table = Node.create({
  name: 'table',
  group: 'block',
  content: 'tableRow+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'table',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['table', HTMLAttributes, 0];
  },
});

export const TableRow = Node.create({
  name: 'tableRow',
  group: 'tableRow',
  content: 'tableCell+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'tr',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['tr', HTMLAttributes, 0];
  },
});

export const TableCell = Node.create({
  name: 'tableCell',
  group: 'tableCell',
  content: 'block+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'td',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'th',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const tag = node.attrs.isHeader ? 'th' : 'td';
    return [tag, HTMLAttributes, 0];
  },
});

export const TableHeader = Node.create({
  name: 'tableHeader',
  group: 'tableCell',
  content: 'block+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'th',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['th', HTMLAttributes, 0];
  },
});

// Table Head extension
export const TableHead = Node.create({
  name: 'tableHead',
  group: 'block',
  content: 'tableRow+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'thead',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['thead', HTMLAttributes, 0];
  },
});

// Table Body extension
export const TableBody = Node.create({
  name: 'tableBody',
  group: 'block',
  content: 'tableRow+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'tbody',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['tbody', HTMLAttributes, 0];
  },
});

// Horizontal Rule extension
export const HorizontalRule = Node.create({
  name: 'horizontalRule',
  group: 'block',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'hr',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['hr', HTMLAttributes];
  },
});

// Line Break extension
export const LineBreak = Node.create({
  name: 'lineBreak',
  group: 'inline',
  inline: true,
  selectable: false,
  parseHTML() {
    return [
      {
        tag: 'br',
      },
    ];
  },
  renderHTML() {
    return ['br'];
  },
});

// Additional semantic elements
export const SemanticElements = Node.create({
  name: 'semanticElements',
  group: 'block',
  content: 'block+',

  addAttributes() {
    return {
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute('class'),
        renderHTML: (attributes) => {
          if (!attributes.class) {
            return {};
          }
          return {
            class: attributes.class,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'header',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'footer',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'nav',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'figure',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'figcaption',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'address',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'cite',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'time',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'mark',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'small',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'sub',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'sup',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'del',
        getAttrs: (element) => {
          return {};
        },
      },
      {
        tag: 'ins',
        getAttrs: (element) => {
          return {};
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    // Determine the tag based on the node name or use div as fallback
    const tag = node.type.name === 'semanticElements' ? 'div' : node.type.name;
    return [tag, HTMLAttributes, 0];
  },
});
